import React from 'react';

import { DatePickerMode } from '@philips-emr/tws-components-api';
import { arrayOf, bool, date, func, object, oneOf, shape, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { enumValues, key } from '@philips-emr/tws-utils';

import DatePickerCell from './date-picker-cell';

function DatePickerRow({ currentDate, endDate, interval, loading, mode, onCellClick, rangeEnabled, ranges, row, startDate }) {
  return (
    <div className="c-date-picker__row">
      {row.map((item) => (
        <DatePickerCell
          currentDate={currentDate}
          endDate={endDate}
          interval={interval}
          item={item}
          key={key('c-date-picker-item')}
          loading={loading}
          mode={mode}
          onClick={onCellClick}
          rangeEnabled={rangeEnabled}
          ranges={ranges}
          startDate={startDate}
        />
      ))}
    </div>
  );
}

DatePickerRow.propTypes = {
  currentDate: date,
  endDate: date,
  interval: bool,
  loading: bool,
  mode: oneOf(enumValues(DatePickerMode)),
  onCellClick: func,
  rangeEnabled: bool,
  row: arrayOf(object),
  ranges: arrayOf(shape({ startDate: string, endDate: string })),
  startDate: date,
};

export default DatePickerRow;
